<template>
  <span ref="container" class="dropdown">
    <button
      class="btn btn-light dropdown-toggle"
      type="button"
      @click="show = !show"
    >
      Settings
    </button>
    <div
      class="dropdown-menu dropdown-menu-right shadow-sm mt-2"
      :class="{ show }"
    >
      <span class="mx-2">Roles</span>
      <div
        v-for="role in availableAppRoles"
        :key="role"
        class="dropdown-item px-2"
        href=""
        @click="updateRole(app, role)"
      >
        <input type="checkbox" :name="role" :checked="roles.includes(role)" />
        <span class="ml-2">{{ role }}</span>
      </div>
      <div class="input-group mb-2 pl-1">
        <input
          v-model="roleInput"
          placeholder="Add Role"
          class="form-control form-control-sm"
        />
        <div class="input-group-append">
          <button
            class="btn btn-primary btn-sm mr-1"
            :disabled="roleInput.length < 1"
            @click="addAppRole()"
          >
            +
          </button>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
      <div class="d-flex mx-1">
        <button class="btn btn-primary btn-sm mx-1" @click="save">
          Save
        </button>
        <button class="btn btn-danger btn-sm mx-1" @click="del">
          Delete
        </button>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    app: { required: true, type: Object },
    allowedRoles: { required: true, type: Array },
  },
  data() {
    return {
      roleInput: "",
      roles: [...this.app.allowed_roles],
      defaultRoles: ["user", "developer", "admin", "auth_admin"],
      show: false,
    }
  },
  computed: {
    availableAppRoles() {
      return Array.from(
        new Set([
          ...this.roles,
          ...this.app.allowed_roles,
          ...this.defaultRoles,
        ]),
      ).sort()
    },
  },
  methods: {
    save() {
      this.show = false
      this.$emit("update-app", {
        cognito_id: this.app.cognito_id,
        roles: this.roles,
      })
    },
    async del() {
      this.show = false
      const confirmation = await this.$alert.fire({
        title: "Delete App?",
        icon: "question",
        input: "text",
        text: "Enter app name to confirm deleting",
      })
      if (confirmation.value === this.app.name) {
        this.$emit("delete-app", { cognito_id: this.app.cognito_id })
      } else {
        this.$alert.fire({
          title: "Error",
          text: `Incorrect name, "${confirmation.value}". Deletion cancelled.`,
          icon: "error",
          position: "top-end",
        })
      }
    },
    updateRole(app, role) {
      const index = this.roles.indexOf(role)
      if (index !== -1) {
        this.roles.splice(index, 1)
      } else {
        this.roles.push(role)
      }
    },
    addAppRole() {
      this.roles.push(this.roleInput.trim())
      this.roleInput = ""
    },
  },
}
</script>
